// src/BankConnectCard.js
import React from 'react';
import './App.css';

const API = 'https://snap2excel-backend.onrender.com';

function BankConnectCard() {
  const handleConnect = () => {
    // IMPORTANT: use full backend URL, not just /api/...
    window.location.href = `${API}/api/tink/start`;
  };

  return (
    <section className="dashboard-row">
      <div className="dashboard-card">
        <h3>Bank connection (beta)</h3>
        <p style={{ fontSize: 13 }}>
          Connect a bank (sandbox) so Snap2Excel can compare what leaves your
          account with what you scan. Your login happens with our open banking
          partner – we never see your banking password.
        </p>
        <button
          className="btn btn-primary"
          style={{ marginTop: 8 }}
          onClick={handleConnect}
        >
          Connect your bank (sandbox)
        </button>
      </div>
    </section>
  );
}

export default BankConnectCard;
